/* eslint-disable react/prop-types */
/* eslint-disable react/display-name */
import React, { Fragment } from "react"
import MaterialTable from "material-table"
import tableIcons from "../../utils/helper"
import { merge, codeSortHelper } from "../../utils/functions"

import { Card, Grid, Button, makeStyles, Modal, Fade, TextField } from "@material-ui/core"

import { useSelector, useDispatch } from "react-redux"
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos"
import LockOutlinedIcon from "@material-ui/icons/LockOutlined"
import CheckOutlinedIcon from "@material-ui/icons/CheckOutlined"
import EditIcon from "@material-ui/icons/Edit"

import * as locationGroupActions from "../../actions/locationGroupActions"
import _ from "lodash"

const LocationGroupSummary = (props) => {
  const dispatch = useDispatch()
  const auth = useSelector((state) => state.auth)
  const classes = useStyles()
  const userType = useSelector((state) => _.get(state, "userInfo.settings.user.userType", ""))
  const allowedLocations = useSelector((state) => _.get(state, "userInfo.settings.locations", []))
  const locationGroups = useSelector((state) => state.locationGroups.data)
  const isFetching = useSelector((state) => state.locationGroups.isFetching)
  const [selectedLocation, setSelectedLocation] = React.useState()
  const [open, setOpen] = React.useState(false)
  const [locationGroupName, setLocationGroupName] = React.useState("")
  const [data, setData] = React.useState()

React.useEffect(() => {
  console.log("allowedLocations", allowedLocations);
  console.log("props.selectedRow.locations.allowed", props.selectedRow?.locations?.allowed);
  
  setData(props.selectedRow
    ? [
        ...allowedLocations.map((rowData) => ({
          ...rowData,
          tableData: {
            checked: props.selectedRow.locations.allowed?.find(
              (e) => e && e.code === rowData.code
            ) !== undefined
          }
        }))
    ].sort(codeSortHelper)
    : [])
}, [props.selectedRow])

  function updateLocations() {
    const locations = data.reduce((acc, e) => {
      if (e.tableData.checked === true) {        
        return acc.concat(e.code);        
      }
      return acc;      
    }, [])
    const locGroup  = {
      ...props.locationGroups[props.selectedRow.tableData.id],
      locations: {
        allowed: locations
      }
    }
    dispatch(locationGroupActions.setLocationGroup({ token: auth.token }, locGroup))
  }

  function checkRow(rowData) {
    if (rowData.length === 0) {
      setData(data.map(e => ({...e, tableData: {...e.tableData, checked: false}})))
    } else {
      setData(merge(data, rowData, (d, r) => d.code === r.code))
    }
  }

  function onDisableGroupButton() {
    const { locations } = locationGroups[props.selectedRow.tableData.id]
    const allowed = locations.allowed.map(e => e.code);
    const locGroup = {
      ...locationGroups[props.selectedRow.tableData.id],
      locations: {
        allowed
      },
      active: false
    };
    dispatch(locationGroupActions.setLocationGroup({ token: auth.token }, locGroup))
  }

  function onEnableGroupButton() {
    const { locations } = locationGroups[props.selectedRow.tableData.id]
    const allowed = locations.allowed.map(e => e.code);
    const locGroup = {
      ...locationGroups[props.selectedRow.tableData.id],
      locations: {
        allowed
      },
      active: true
    };
    dispatch(locationGroupActions.setLocationGroup({ token: auth.token }, locGroup))
  }

  function handleClose() {
    setOpen(false)
  }

  function buttonsDisabled() {
    return !(locationGroups && locationGroups.length > 0) || isFetching
  }

  function updateLocationGroupName() {
    const locations = data.reduce((acc, e) => {
      if (e.tableData.checked === true) {        
        return acc.concat(e.code);        
      }
      return acc;      
    }, [])

    let locationGroup = {
      _id: locationGroups[props.selectedRow.tableData.id]._id,
      name: locationGroupName,
      locations: {
        allowed: locations
      },
      active: locationGroups[props.selectedRow.tableData.id].active,
    }

    dispatch(locationGroupActions.setLocationGroup({ token: auth.token }, locationGroup))
    setOpen(false)
    setLocationGroupName("")
  }

  return (
    <Fragment>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={open}
        onClose={handleClose}
        closeAfterTransition
      >
        <Fade in={open}>
          <div className={classes.paper}>
            <h2 id="transition-modal-title">Change Location Group Name</h2>
            <p id="transition-modal-description">
              <TextField
                onChange={(e) => setLocationGroupName(e.target.value)}
                value={locationGroupName}
                label={"Location Group Name"}
                variant="outlined"
                margin="dense"
                fullWidth
              ></TextField>
            </p>
            <div style={{ textAlign: "center" }}>
              <Button
                variant="contained"
                size="medium"
                color="secondary"
                style={{ margin: "5px" }}
                onClick={updateLocationGroupName}
              >
                Change
              </Button>
              <Button variant="contained" size="medium" color="primary" onClick={handleClose} style={{ margin: "5px" }}>
                Cancel
              </Button>
            </div>
          </div>
        </Fade>
      </Modal>
      <Grid item xs={7} lg={5}>
        <Card className={classes.summaryCardActive}>
          {props.locationGroups && props.locationGroups && props.selectedRow && locationGroups && locationGroups.length > 0 && (
            <MaterialTable
              icons={tableIcons}
              title="Location Codes"
              columns={[
                { title: "Code", field: "code", width: "auto" },
                { title: "Name", field: "name", width: "auto" },
                // { title: "active", field: "active" }
                // { title: "ID", field: "id", hidden: "true" }
                /* { title: 'Allowed', field: 'allowed' , type: 'boolean'}, */
              ]}
              options={{
                minBodyHeight: "calc(100vh - 224px)",
                maxBodyHeight: "calc(100vh - 224px)",
                pageSize: 300,
                paging: true,
                paginationType: "normal",
                rowStyle: (rowData) => ({
                  backgroundColor:
                    selectedLocation && selectedLocation.tableData.id === rowData.tableData.id ? "#EEE" : "#FFF",
                }),
                selection: true
              }}
              isLoading={isFetching}
              data={data}
              onRowClick={(event, rowData) => {
                setSelectedLocation(rowData)
              }}
              onSelectionChange={(rowData) => {
                checkRow(rowData)
              }}
            />
          )}
        </Card>
        <Grid container direction="row" justify="flex-start" alignItems="flex-start" style={{ marginTop: 10 }}>
          <Card style={{ width: "100%", height: "100%" }} className={classes.actionButtonsCard}>
            <Grid container direction="row" justify="space-between" alignItems="center">
              {props.selectedRow &&
                (userType == "SERVICE_MANAGER" || userType == "ADMIN") &&
                locationGroups[props.selectedRow.tableData.id] &&
                locationGroups[props.selectedRow.tableData.id].active && (
                  <Grid item xs={4} style={{ textAlign: "left", paddingLeft: 15 }}>
                    {props.selectedRow && (
                      <Button color="primary" disabled={buttonsDisabled()} onClick={onDisableGroupButton}>
                        <LockOutlinedIcon
                          style={{
                            marginRight: 5,
                            fontSize: 20,
                            marginBottom: 2,
                          }}
                        ></LockOutlinedIcon>
                        Disable Location Group
                      </Button>
                    )}
                  </Grid>
                )}
              {props.selectedRow &&
                (userType == "SERVICE_MANAGER" || userType == "ADMIN") &&
                locationGroups[props.selectedRow.tableData.id] &&
                !locationGroups[props.selectedRow.tableData.id].active && (
                  <Grid item xs={6} style={{ textAlign: "left", paddingLeft: 15 }}>
                    {props.selectedRow && (
                      <Button color="primary" onClick={onEnableGroupButton} disabled={buttonsDisabled()}>
                        <CheckOutlinedIcon
                          style={{
                            marginRight: 5,
                            fontSize: 20,
                            marginBottom: 2,
                          }}
                        ></CheckOutlinedIcon>
                        Enable Location Group
                      </Button>
                    )}
                  </Grid>
                )}
              <Grid item xs={4} style={{ paddingRight: 15 }}>
                {props.selectedRow && (userType == "SERVICE_MANAGER" || userType == "ADMIN") && (
                  <Button color="primary" onClick={() => setOpen(true)} disabled={buttonsDisabled()}>
                    <EditIcon
                      style={{
                        marginRight: 10,
                        fontSize: 20,
                        marginBottom: 2,
                      }}
                    ></EditIcon>
                    EDIT GROUP NAME
                  </Button>
                )}
              </Grid>
              <Grid item xs={4} style={{ paddingRight: 15 }}>
                {props.selectedRow && (userType == "SERVICE_MANAGER" || userType == "ADMIN") && (
                  <Button color="primary" onClick={updateLocations} disabled={buttonsDisabled()}>
                    Update Locations
                    <ArrowForwardIosIcon style={{ marginLeft: 5, fontSize: 20, marginBottom: 2 }}></ArrowForwardIosIcon>
                  </Button>
                )}
              </Grid>
            </Grid>
          </Card>
        </Grid>
      </Grid>
    </Fragment>
  )
}

const cardWidget = {
  textAlign: "center",
  height: "100%",
  width: "100%",
  padding: "20px 0 10px 0",
  position: "relative",
  overflow: "hidden",
}

const useStyles = makeStyles((theme) => ({
  root: {
    "& button.MuiButtonBase-root": {
      padding: "5px",
    },
  },
  actionButtonsCard: {
    paddingTop: 7,
    minHeight: 51,
    height: "100%",
    width: "100%",
    textAlign: "right",
  },
  summaryCard: {
    height: "calc(100vh - 106px)",
  },
  summaryCardActive: {
    height: "calc(100vh - 168px)",
  },
  vehicleCard: cardWidget,
  progress: {
    margin: theme.spacing(2),
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: "none",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    minWidth: "25%",
    minHeight: "25%",
  },
  customerDetails: {
    "& input": {
      fontSize: "14px",
      color: "#000",
      padding: "5px 0",
    },
    "& label.Mui-disabled": {
      fontSize: "13px",
      color: "#B9BBBE",
    },
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    border: "none",
  },
  infoCard: {
    ...cardWidget,
    padding: "10px 0 10px 0",
    "& .MuiCardContent-root": {
      paddingTop: "0",
      paddingBottom: "0",
    },
    "& .MuiTextField-root": {
      margin: "0px",
    },
    "& input": {
      fontSize: "14px",
      color: "#000",
      padding: "5px 0",
    },
    "& .MuiInputBase-root": {
      marginTop: "12px",
    },
    "& label.Mui-disabled": {
      fontSize: "13px",
      color: "#B9BBBE",
    },
  },
}))

export default LocationGroupSummary
